import { AfterViewInit, Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateHelper } from '@app/_helpers';
import { DirectionService } from '@app/_services/direction.service';
import { TranslateService } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { ClickDirective } from '../../shared/directives/click.directive';
import { OwlPreventClickDirective } from '../../shared/directives/owl-prevent-click.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SectorsMenu } from '../../_components/sectors-menu/sectors-menu.component';
import { NgIf, NgFor, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-block-slideshow-withbtn',
    templateUrl: './block-slideshow-withbtn.component.html',
    styleUrls: ['./block-slideshow-withbtn.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, SectorsMenu, CarouselModule, OwlPreventClickDirective, NgFor, ClickDirective, RouterLink, NgTemplateOutlet]
})
export class BlockSlideshowWithButtonComponent {
    @Input() withDepartments = true;

    @Input() slides = [];

    options = {
        nav: false,
        dots: true,
        loop: false,
        rewind: true,
        autoplay: true,
        responsive: {
            0: { items: 1 }
        },
        rtl: this.direction.isRTL()
    };
    isRTL = this.direction.isRTL();


    constructor(
        public sanitizer: DomSanitizer,
        private direction: DirectionService,
        public translationHelper: TranslateHelper,
        public translate: TranslateService,
    ) {
    }
}
